<!--
 * @Author: your name
 * @Date: 2021-08-28 17:46:28
 * @LastEditTime: 2021-08-30 14:47:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /szpwz_official_web/src/views/user/center/myTicketOrder.vue
-->

<template>
  <div class="page" v-if="page.total > 0" v-show="!showDetail">
    <div class="list">
      <div class="list-item" v-for="(item, index) in page.list" :key="index">
        <div class="list-item-top">
          <div class="title">预约景点：{{ item.reserve_spot_name }}</div>
          <div class="state">
            <span v-show="item.order_status == 0">已预约</span>
            <span v-show="item.order_status == 1">已核销</span>
            <span v-show="item.order_status == 2">已过期</span>
          </div>
        </div>
        <div class="list-item-bottom">
          <div class="title">预约日期：{{ item.reserve_date }}</div>
          <div class="time">
            时间段：{{ item.start_time + "~" + item.end_time }}
          </div>
          <div class="num">游客数量：{{ item.tourist_num }}</div>
          <div class="phone">联系手机：{{ item.phone_num }}</div>
          <div class="a">
            <a @click="handelDetail(item)">查看详情</a>
          </div>
        </div>
      </div>
    </div>

    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      background
      :current-page="page.currentPage"
      :page-size="page.pageSize"
      prev-text="上一页"
      next-text="下一页"
      layout="prev, pager, next, jumper, total"
      :total="page.total"
    >
    </el-pagination>
  </div>
  <el-empty v-else description="您还没有预约"> </el-empty>

  <div class="detail" v-show="showDetail">
    <div class="back">
      <a @click="goBackToList()">返回列表</a>
    </div>
    <div class="base-info">
      <div><span>订单号：</span>{{ detail.reserve_order_num }}</div>
      <div><span>联系手机：</span>{{ detail.phone_num }}</div>
      <div><span>预约日期：</span>{{ detail.reserve_date }}</div>
      <div>
        <span>时间段：</span>{{ detail.start_time + "~" + detail.end_time }}
      </div>
      <div><span>游客数量：</span>{{ detail.tourist_num }}</div>
    </div>
    <div class="tourist-list">
      <div class="list-item">游客信息：</div>
      <div
        class="list-item"
        v-for="(item, index) in detail.touristList"
        :key="index"
      >
        {{ index + 1 + "、" }}
        {{ item.tourist_name }}
        {{ item.cert_num }}
        {{ item.phone_num }}
      </div>
    </div>
    <div class="desc">
      <span>使用说明：</span>
      <div>
        <span>入园方式</span>
        二维码-凭有效预约二维码扫码入园
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "myTicketOrder",
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
        list: [],
      },

      showDetail: false,
      detail: {},
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getPageList();
    },
    async getPageList() {
      let result = await this.$apiUtil.ticketApi.order.getOrderPage(
        this.page.currentPage,
        this.page.pageSize,
        "",
        ""
      );
      if (result.returnCode === 1) {
        this.page.list = result.result.list;
        this.page.total = result.result.total;
        this.page.currentPage = result.result.pageNum;
      }
    },
    async handelDetail(item) {
      let result = await this.$apiUtil.ticketApi.order.getOrderDetail(
        item.int_id,
        ""
      );
      if (result.returnCode === 1) {
        this.detail = result.result;
        this.showDetail = true;
      } else {
        this.$message(result.description);
      }
    },
    goBackToList() {
      this.showDetail = false;
    },
  },
  mounted() {
    this.getPageList();
  },
};
</script>
<style lang="less" scoped>
.page {
  .list {
    min-height: 600px;
    .list-item {
      border: 1px solid #fdd78b;
      margin: 10px 0;

      .list-item-top {
        height: 40px;
        background: #fdf8ee;
        padding: 0 20px;

        font-size: 16px;
        font-weight: 400;
        color: #fdc75a;
        line-height: 24px;

        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .list-item-bottom {
        padding: 30px 20px 20px 20px;

        display: flex;
        align-items: center;
        justify-content: space-between;

        div {
          text-align: left;
          width: 180px;
        }

        .a {
          text-align: right;

          a {
            cursor: pointer;
            padding: 5px;

            font-size: 14px;
            font-weight: 400;
            color: #ff7800;
            line-height: 24px;
            background: none;
            border: none;
          }
        }
      }
    }
  }

  :deep(.el-pagination) {
    margin-top: 40px !important;

    .btn-prev,
    .btn-next,
    .el-pagination__jump,
    .el-pagination__total {
      border: 1px solid #fdd78b !important;
    }

    .el-pager {
      .active {
        background-color: #fdc75a !important;
      }

      .number {
        border: 1px solid #fdd78b !important;
      }
    }
  }
}

.detail {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 49px;
  text-align: left;

  span {
    width: 150px;
  }

  .base-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    text-align: left;

    div {
      width: 40%;
    }
  }
  .tourist-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 40px;
    text-align: left;

    .list-item {
      width: 100%;
    }
  }
  .desc {
    margin-top: 40px;
  }

  .back {
    a {
      background-color: #fdf8ee;
      border: none;
      color: #ff7800;
      cursor: pointer;
      padding: 5px;
    }
  }
}
</style>